<div class="product-list-item-list">
  <div class="p-0 d-flex flex-column justify-content-end"></div>
  <div class="row p-0">
    <div class="col-12 col-lg-7">
      <div class="d-flex align-items-center">
        <div class="thumbnail-container text-center p-2 position-relative">
          <a
            [routerLink]="['/product', 'detail']"
            [queryParams]="{ productNumber: productListProduct.productIdentifier?.productNumber, quantityUnit: productListProduct.salesUnit?.quantityUnit }"
            [class.lechaibg]="productListProduct.isWineShopProduct"
          >
            <img class="thumbnail position-relativ" [src]="productListProduct.thumbnail" alt="thumbnail" />
          </a>
          @if (contextService.contextGet() == "myShop") {
            @if (authService.isAuthenticated() && productListProduct.isFavorite == true) {
              <div class="favorite-container">
                <app-product-favorite-icon [productIdentifier]="productListProduct.productIdentifier" [isFavorite]="productListProduct.isFavorite" (onFavoriteRemove)="onProductRemove.emit()"> </app-product-favorite-icon>
              </div>
            }
          }
        </div>
        <div class="d-flex flex-column descriptioncontainer">
          <div class="promotagcontainer">
            @if (productListProduct.productTagList != undefined && productListProduct.productTagList.length > 0) {
              <app-product-tag-pictogram [productTagList]="productListProduct.productTagList"></app-product-tag-pictogram>
              @if (isAuthenticated) {
                <app-product-tag-list [productTagList]="productListProduct.productTagList"></app-product-tag-list>
              }
            }
          </div>

          <div class="description fw-bold overflow-hidden">
            <a class="description-container" [routerLink]="['/product', 'detail']" [queryParams]="{ productNumber: productListProduct.productIdentifier?.productNumber, quantityUnit: productListProduct.salesUnit?.quantityUnit }">
              <span>{{ productListProduct.description }}</span>
            </a>
          </div>

          <div class="product-attribute-row">
            @if (productListProduct.salesUnit?.quantityUnitCaption != undefined) {
              <span class="product-attribute">{{ productListProduct.salesUnit | quantityUnitToString }}</span>
            }

            <!-- hide packaging type in case it is the same as quantity unit -->
            @if (productListProduct.packagingType != undefined && (productListProduct.packagingType | packagingToStringPipe) != (productListProduct.salesUnit | quantityUnitToPluralString)) {
              <span class="product-attribute">{{ productListProduct.packagingType | packagingToStringPipe }}</span>
            }
          </div>

          <div class="small mb-3">
            <span i18n="@@ProductListProductEntryItemNumber">Item # </span>
            <a [routerLink]="['/product', 'detail']" [queryParams]="{ productNumber: productListProduct.productIdentifier?.productNumber, quantityUnit: productListProduct.salesUnit?.quantityUnit }">
              {{ productListProduct.productIdentifier?.productNumber }}</a
            >
          </div>
        </div>
      </div>
    </div>
    <div class="col-12 col-lg-5">
      <div class="d-flex justify-content-end h-100">
        <div class="d-inline-flex align-items-center order-2 order-lg-2">
          <app-price-card-price [priceTemplateData]="productListProduct.priceTemplateData"> </app-price-card-price>
        </div>

        @if (isAuthenticated != true) {
          <div class="cart-button-container d-inline-flex align-items-center justify-content-center order-1 order-lg-1">
            <ng-container *ngTemplateOutlet="loginButton"></ng-container>
          </div>
        }

        @if (isAuthenticated == true) {
          <div class="cart-button-container d-inline-flex align-items-center justify-content-center order-4 order-lg-3">
            @if (productListProduct.productStockIsLoading == true || isLoading) {
              <ng-container *ngTemplateOutlet="loadingButton"></ng-container>
            }
            @if (productListProduct.productStockIsLoading != true && isLoading != true) {
              @if (productListProduct.priceTemplateData?.orderUnitPrice?.shouldDisplayPriceOnRequest == true) {
                <ng-container *ngTemplateOutlet="infoButton"></ng-container>
              }
              @if (productListProduct.priceTemplateData?.orderUnitPrice?.shouldDisplayPriceOnRequest != true) {
                @if (productListProduct.priceTemplateData?.orderPriceMark == ePriceMark.NoPrice) {
                  <ng-container *ngTemplateOutlet="banButton"></ng-container>
                }

                @if (productListProduct.priceTemplateData?.orderPriceMark == undefined || productListProduct.priceTemplateData?.orderPriceMark != ePriceMark.NoPrice) {
                  @switch (productListProduct.productStockInformation?.productAvailabilityState) {
                    @case (eProductAvailabilityState.Green) {
                      <ng-container *ngTemplateOutlet="cartButton; context: { $implicit: productListProduct }"> </ng-container>
                    }
                    @case (eProductAvailabilityState.Yellow) {
                      <ng-container *ngTemplateOutlet="cartButton; context: { $implicit: productListProduct }"> </ng-container>
                    }
                    @case (eProductAvailabilityState.Red) {
                      <ng-container *ngTemplateOutlet="notifyButton; context: { $implicit: productListProduct }"> </ng-container>
                    }
                    @case (eProductAvailabilityState.Car) {
                      <ng-container *ngTemplateOutlet="notifyButton; context: { $implicit: productListProduct }"> </ng-container>
                    }
                    @default {
                      <ng-container *ngTemplateOutlet="infoButton"></ng-container>
                    }
                  }
                }
              }
            }
          </div>
          <app-product-add-to-cart-template-icon class="d-flex order-1 order-lg-4" [productIdentifier]="productListProduct.productIdentifier" [quantityUnit]="productListProduct.salesUnit" [quantity]="productListProduct.minimumOrderAmount">
          </app-product-add-to-cart-template-icon>
        }
      </div>
    </div>
  </div>
</div>

<ng-template #loadingButton>
  <button type="button" class="btn btn-secondary action h-100" disabled>
    <app-loading-indicator-base [loadingIndicatorStyle]="eLoadingIndicatorStyle"></app-loading-indicator-base>
  </button>
</ng-template>

<ng-template #loginButton>
  <button type="button" class="btn btn-secondary action h-100" [routerLink]="['/login']">
    <i class="bi bi-cart4 mx-1"></i>
  </button>
</ng-template>

<ng-template #cartButton let-productListProduct>
  @if (isShoppingCartDefined != true) {
    <ng-container *ngTemplateOutlet="createCartButton"></ng-container>
  }

  @if (isShoppingCartDefined == true) {
    @if (shoppingCartItem == undefined && !isExportBanned) {
      <ng-container *ngTemplateOutlet="addToCartButton; context: { $implicit: productListProduct }"></ng-container>
    }
    @if (shoppingCartItem == undefined && isExportBanned) {
      <ng-container *ngTemplateOutlet="banButton"></ng-container>
    }
    @if (shoppingCartItem != undefined) {
      <app-quantity-input-bare
        class="mx-4 my-auto"
        [min]="minimumOrderAmount"
        [max]="maximumOrderAmount"
        [quantity]="shoppingCartItem.quantity"
        [accept]="acceptQuantityChangeTrigger.asObservable()"
        [reject]="rejectQuantityChangeTrigger.asObservable()"
        (onQuantityChanged)="quantityChangedAsync($event)"
        (onProductRemoveFromCart)="deleteFromCart()"
      >
      </app-quantity-input-bare>
    }
  }
</ng-template>

<ng-template #infoButton>
  <button type="button" class="btn btn-light action h-100" disabled>
    <img role="img" src="assets/images/shoppingcart_slashed.png" class="cart-slashed" />
  </button>
</ng-template>

<ng-template #banButton>
  <button type="button" class="btn btn-light action h-100" disabled>
    <img role="img" class="cart-slashed" src="assets/images/shoppingcart_slashed.png" />
  </button>
</ng-template>

<ng-template #createCartButton>
  <button type="button" class="btn btn-secondary action h-100" (click)="createCartClickAsync()">
    <i class="bi bi-cart4 mx-1"></i>
  </button>
</ng-template>

<ng-template #addToCartButton let-productListProduct>
  @if (shoppingCartItem == undefined) {
    <button type="button" class="btn btn-secondary action h-100" (click)="addToCartClickAsync(productListProduct)">
      <i class="bi bi-cart4 mx-1"></i>
    </button>
  }
  @if (shoppingCartItem != undefined) {
    <app-quantity-input-bare [min]="minimumOrderAmount" [max]="maximumOrderAmount" [quantity]="shoppingCartItem.quantity" (onQuantityChanged)="quantityChangedAsync($event)" (onProductRemoveFromCart)="deleteFromCart()"> </app-quantity-input-bare>
  }
</ng-template>

<ng-template #notifyButton let-productListProduct>
  @if (productListProduct.hasAvailabilityNotification != undefined) {
    @if (productListProduct.hasAvailabilityNotification != true) {
      <button type="button" class="btn btn-light action h-100" (click)="availabilityNotificationCreateClickAsync(productListProduct)">
        <i class="bi bi-bell"></i>
      </button>
    }
    @if (productListProduct.hasAvailabilityNotification == true) {
      <button type="button" class="btn btn-light action h-100" (click)="availabilityNotificationDeleteClickAsync(productListProduct)">
        <i class="bi bi-bell-slash"></i>
      </button>
    }
  }
  @if (productListProduct.hasAvailabilityNotification == undefined) {
    <ng-container *ngTemplateOutlet="infoButton"></ng-container>
  }
</ng-template>
